import PropTypes from 'prop-types';
// material
import { alpha, styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Button, Link, Typography } from '@mui/material';
// components
import { useLocation } from 'react-router-dom';
import Iconify from '../../components/Iconify';
//
import Searchbar from '../dashboard/Searchbar';
import AccountPopover from '../dashboard/AccountPopover';
import LanguagePopover from '../dashboard/LanguagePopover';
import NotificationsPopover from '../dashboard/NotificationsPopover';
import Logo from '../../components/Logo';
import useResponsive from '../../hooks/useResponsive';
import LucideIcon from '../../components/LucideIcon';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 64;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: 'white',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100%)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

const menuLinks = [
  {
    label: 'Mes événements',
    href: '/bo/',
    icon: 'mdi-light:calendar',
    icon2: 'CalendarDays',
  },
  {
    label: 'Organisation',
    href: '/organisation/app',
    icon: 'uil:setting',
    icon2: 'Building2',
  },
  {
    label: 'Finance',
    href: '/finance',
    icon: 'carbon:finance',
    icon2: 'Landmark',
  },
  {
    label: 'Marketing',
    href: '/marketing',
    icon: 'nimbus:marketing',
    icon2: 'Megaphone',
  }, /*
  {
    label: 'Analyse',
    href: '/marketing', // Change ici si tu as une autre route
    icon: 'ion:analytics-outline',
  }, */
];

HomeNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function HomeNavbar({ onOpenSidebar }) {
  const smUp = useResponsive('up', 'sm');
  const mdUp = useResponsive('up', 'md');
  const location = useLocation();
  return (
    <RootStyle>
      <ToolbarStyle>
        <Logo />

        {mdUp ? (
          <>
            <Box sx={{ flexGrow: 1 }} />
            <Stack direction="row" textAlign="center" spacing={{ xs: 0.5, sm: 1 }}>
              {menuLinks.map((link) => {
                const isActive = location.pathname.startsWith(link.href);

                return (
                  <Button key={link.label} sx={{
                    color: isActive ? '#5E17EB' : 'text.secondary',
                    bgcolor: isActive ? alpha('#5E17EB',0.08) : 'transparent',
                    backdropFilter: "blur(8px)", // flou
                    // backgroundColor: "transparent", // transparent blanc
                    border: "1px solid transparent", // léger contour
                    // boxShadow: "0 4px 20px rgba(0,0,0,0.2)", // ombre moderne
                    borderRadius: "12px",
                    transition: "all 0.3s ease",
                    textTransform: 'initial',
                    "&:hover": {
                      background: "rgba(255, 255, 255, 0.63)",
                      color: 'text.primary',
                      bgcolor: '#f2f2f2',
                      border: "1px solid transparent", // léger contour
                      // transform: "scale(1.025)",
                    },
                  }} href={isActive ? undefined : link.href} size="large" variant="outlined" startIcon={<LucideIcon name={link.icon2} />}>
                    <Typography variant='body1' fontWeight={500} noWrap>{link.label}</Typography>
                  </Button>
                );
              })}
            </Stack>
            
            <Stack direction="row" alignItems="center" paddingLeft={2} spacing={{ xs: 0.5, sm: 1.5 }}>

              <Button
                sx={{
                  color: '#5E17EB',
                  backgroundColor: 'white',
                  border: '1.5px solid #5E17EB',
                  borderRadius: '7px',
                  '&:hover': {
                    backgroundColor: 'white',
                    color: '#5E17EB',
                    border: '1.5px solid #5E17EB',
                  },
                }}
                variant="outlined"
              >
                Nous contacter
              </Button>
              <AccountPopover />
            </Stack>
          </>
        ) : <>
          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
            <Button
              sx={{
                color: '#5E17EB',
                backgroundColor: 'white',
                border: '1.5px solid #5E17EB',
                borderRadius: '7px',
                '&:hover': {
                  backgroundColor: 'white',
                  color: '#5E17EB',
                  border: '1.5px solid #5E17EB',
                },
              }}
              variant="outlined"
            >
              Nous contacter
            </Button>
            <AccountPopover />
          </Stack>
        </>}
      </ToolbarStyle>
    </RootStyle>
  );
}
